module.exports = __webpack_public_path__ + "img/image_first_left.3a62483a.png";